import { render, staticRenderFns } from "./PerformanceCard.vue?vue&type=template&id=4b528c46"
import script from "./PerformanceCard.vue?vue&type=script&lang=ts"
export * from "./PerformanceCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports